/*
 * @Author: miroku.yang
 * @Date: 2024-04-30 16:29:21
 * @LastEditors: Please set LastEditors
 * @Description:
 */
/**
 * 创意灵感布局
 */

import * as React from 'react'
import classNames from 'classnames'
import { useTranslation } from '@/libs/next-lang'
import { GIVEAWAY_CHANNEL } from '@/constants'
import { inspirationRoutes } from '@/utils/routes'
import { IconSvg } from '@/components'
import { GiftModal } from '@/page-components/components'
import styles from './index.module.less'

export default function Index({
  giveawayChannel,
  query,
  pathname,
  children,
  isPersonal,
  userInfo,
  memberReceiveShow,
  onCollect,
  onChange,
}: any) {
  const { t } = useTranslation(["inspiration"])

  const renderHeader = () => {
    // 过滤掉一级菜单
    const menus: any = inspirationRoutes.filter((m: any) => !m.showItem)
    const visible: boolean = [query.channel, giveawayChannel, query.platformOwner].includes(
      GIVEAWAY_CHANNEL.GOOGLE,
    )
    if (visible) {
      return <div style={{ paddingTop: 20, display: 'flex' }} />
    }
    if (menus?.length > 0) {
      return (
        <div className={styles['menu-wrap']}>
          <div key={menus.length} className={styles.menu}>
            {menus.map((m: any, index: number) => (
              <div
                key={m.path}
                className={classNames(styles['menu-item'], {
                  [styles['menu-active']]: pathname === m.path,
                })}
                onClick={() => onChange?.(m.path)}
              >
                {index === 0 && (
                  <div className={styles.icon}>
                    <img src="/images/icons/GoodsFox.svg" />
                  </div>
                )}
                <span>{t(m.translateKey)}</span>
              </div>
            ))}
          </div>
          <span className={styles['collect-wrap']} onClick={onCollect}>
            <IconSvg type="icon-shoucang" style={{ fontSize: 14, marginRight: 8 }} />
            {t('inspiration:t62')}
          </span>
        </div>
      )
    }
    return null
  }
  return (
    <div className={styles['inspiration-layout']}>
      <div id="inspiration-layout-container" className={styles['inspiration-layout-container']}>
        {renderHeader()}
        <div className={styles.container}>{children}</div>
      </div>
      <GiftModal
        isPersonal={isPersonal}
        userInfo={userInfo}
        memberReceiveShow={memberReceiveShow}
      />
    </div>
  )
}
